export default "__VITE_ASSET__DiC3I6dc__"